import {
  RouteReuseStrategy,
  DetachedRouteHandle,
  ActivatedRouteSnapshot,
} from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  handlers: { [key: string]: DetachedRouteHandle | null } = {};

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.isReusableRoute(route);
  }

  store(
    route: ActivatedRouteSnapshot,
    handle: DetachedRouteHandle | null,
  ): void {
    if (this.isReusableRoute(route)) {
      this.handlers[this.getRouteKey(route)] = handle;
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return (
      this.isReusableRoute(route) && !!this.handlers[this.getRouteKey(route)]
    );
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (!route.routeConfig || !this.isReusableRoute(route)) {
      return null;
    }
    return this.handlers[this.getRouteKey(route)] || null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    if (
      future.routeConfig === curr.routeConfig &&
      curr.routeConfig &&
      curr.routeConfig.data &&
      curr.routeConfig.data['reuse'] == true
    )
      return true;
    return false;
  }

  private getRouteKey(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map((segment) =>
        segment.url.map((urlSegment) => urlSegment.toString()).join('/'),
      )
      .join('/');
  }

  private isReusableRoute(route: ActivatedRouteSnapshot): boolean {
    return (
      route.routeConfig &&
      route.routeConfig.data &&
      route.routeConfig.data['reuse']
    );
  }
}
